import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, requireOnboarded = false }) => {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="text-muted-foreground font-serif text-2xl tracking-wide">Tending the garden…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;
    return children;
};
